import { IssueCreatedAndResolvedTaskComparisonReportResult } from '@tap/data-providers';
import { XGridTableWrap } from '@tap/mui-ui';
import { dateTimeHelper } from '@tap/utils';

/* Таблица "Созданные vs Завершённые заявки"
*/

type CreatedAndResolvedTaskComparisonTableProps = {
    initialData: IssueCreatedAndResolvedTaskComparisonReportResult[],
}

export default function CreatedAndResolvedTaskComparisonTable({ initialData }: CreatedAndResolvedTaskComparisonTableProps) {

    return (
        <XGridTableWrap
            rows={initialData}
            dataIsLoading={false}
            tableHeight={'calc(100vh - 160px)'}
            tableWidth={'90%'}
            columns={[
                {
                    field: 'date',
                    headerName: 'Дата',
                    sortable: false,
                    type: 'date',
                    flex: 1,
                    renderCell: cellParams => dateTimeHelper.formatDate(new Date(cellParams.row.date), 'dd MMMM yyyy'),
                    valueGetter: value => new Date(value),
                },
                {
                    field: 'createdCount',
                    headerName: 'Создано заявок',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                },
                {
                    field: 'completedCount',
                    headerName: 'Завершено заявок',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                },
            ]}

        />
    );
}

